import type { FeatureGroup } from '../../../types';
import { PAYMENTS_FEATURE_GROUP } from '../group';

export const PAYMENTS_INTEGRATIONS_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f04ff',
  name: 'payments_integrations',
  description: 'Third-party integrations payments pushes transactions into',
  product: 'payments',
  parentGuid: PAYMENTS_FEATURE_GROUP.guid,
};
